import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { graphql, useStaticQuery } from 'gatsby';

import Icon from 'components/UI/Icon';
import Logos from 'components/Elements/LogosList';
import News from './News';

import useIntersection from 'hooks/useIntersection';
import * as styles from './cases.module.scss';

const Cases = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 1,
  });

  const {
    allFile: { nodes },
  } = useStaticQuery(graphql`
    query getCareersLogos {
      allFile(filter: { relativeDirectory: { eq: "common/logos" } }) {
        nodes {
          name
          relativePath
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
          }
        }
      }
    }
  `);

  return (
    <section className={classnames(styles.section)} ref={scrollWrapper}>
      <div className="cr-wrap">
        <div>
          <div
            className={classnames(
              styles.header,
              inViewSec && styles.jsAnimInit
            )}
            ref={inViewRefSec}
          >
            <h2 className={classnames(styles.title, 'cr-h2')}>
              {data.title && data.title}
            </h2>
            <Link
              to={'#'}
              className={classnames(
                'cr-btn cr-btn--icon cr-btn--large cr-btn--icon-red-txt'
              )}
            >
              Request product tour
              <Icon name="corner-arrow-small-bold" />
            </Link>
          </div>
          <Logos logos={nodes} />

          <News data={data.list_news} />
        </div>
      </div>
    </section>
  );
};

export default Cases;
